import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  roles: [],
  authorities: [],
  role: null,
  authority: null,
  token: null
}

const mutations = {
  // {"sidebarShow":"responsive","sidebarMinimize":false,"roles":["ROLE_EDITOR"],"role":{"ROLE_ADMIN":true,"ROLE_EDITOR":true},"authority":null}

  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  addUser(state, user) {
    state.role = null;
    state.roles = [];
    state.authorities = [];
    state.authority = null;

    console.log("addUser state", state, JSON.stringify(state));
    console.log("addUser user", user, JSON.stringify(user));
    state["token"] = user.token;
    state["roles"] = user.claims.roles;
    state["authorities"] = user.claims.authorities;
    if (user.claims.roles) {
      let rBind = {}
      for (let role in user.claims.roles) {
        rBind[user.claims.roles[role]] = true;
      }
      state.role = {...state.role, ...rBind}
    }
    if (user.claims.authorities) {
      let aBind = {}
      for (let authority in user.claims.authorities) {
        aBind[user.claims.authorities[authority]] = true;
      }
      state.authority = {...state.authority, ...aBind}
    }
    console.log("last addUser state", state, JSON.stringify(state));
  }
}

export default new Vuex.Store({
  state,
  mutations
})